document.addEventListener('DOMContentLoaded', function () {

  // =========================
  // MOBILE MENU
  // =========================

  const menu = document.querySelector('[data-tm-mobile-menu]');
  const backdrop = document.querySelector('[data-tm-mobile-backdrop]');
  const openButtons = document.querySelectorAll('[data-tm-menu-open]');
  const closeButtons = document.querySelectorAll('[data-tm-menu-close]');


  let menuTrigger = null;
  let priorOverflow = "";
  function openMenu(event) {
    if (!menu) return;

    menuTrigger = event && event.currentTarget;
    priorOverflow = document.body.style.overflow;
    menu.inert = false;
    menu.setAttribute('aria-hidden', 'false');
    openButtons.forEach(button => button.setAttribute('aria-expanded', 'true'));
    menu.classList.add('is-open');
    const close = menu.querySelector('[data-tm-menu-close]');
    if (close) close.focus();

    if (backdrop) {
      backdrop.classList.add('is-open');
    }

    document.body.style.overflow = 'hidden';
  }


  function closeMenu() {
    if (!menu || !menu.classList.contains('is-open')) return;
    menu.inert = true;
    menu.setAttribute('aria-hidden', 'true');
    openButtons.forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (menuTrigger) menuTrigger.focus();

    menu.classList.remove('is-open');

    if (backdrop) {
      backdrop.classList.remove('is-open');
    }

    document.body.style.overflow = priorOverflow;
  }


  openButtons.forEach(button => {
    button.addEventListener('click', openMenu);
  });


  closeButtons.forEach(button => {
    button.addEventListener('click', closeMenu);
  });


  // Close when clicking outside the drawer
  if (backdrop) {
    backdrop.addEventListener('click', closeMenu);
  }


  // Close with Escape key
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab' && menu && menu.classList.contains('is-open')) {
      const focusable = Array.from(menu.querySelectorAll('a, button, summary, input, select, textarea, [tabindex="0"]')).filter(el => el.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
    }
    if (event.key === 'Escape') {
      closeMenu();
    }
  });


  // Close drawer after clicking a normal mobile menu link
  document
    .querySelectorAll('[data-tm-mobile-menu] a')
    .forEach(link => {
      link.addEventListener('click', function () {
        closeMenu();
      });
    });


  // =========================
  // PRODUCT IMAGE GALLERY
  // =========================

  document
    .querySelectorAll('[data-tm-product-thumb]')
    .forEach(button => {

      button.addEventListener('click', function () {

        const image = button.dataset.image;
        const mainImage = document.querySelector('[data-tm-main-image]');

        if (image && mainImage) {
          mainImage.removeAttribute('srcset');
          mainImage.src = image;
          const thumbImage = button.querySelector('img');
          if (thumbImage) mainImage.alt = thumbImage.alt;
        }

      });

    });


  document.querySelectorAll('[data-tm-product]').forEach(section => {
    const select = section.querySelector('[data-tm-variant]');
    if (!select) return;
    const updateVariant = () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      const price = section.querySelector('[data-tm-product-price]');
      const button = section.querySelector('[data-tm-add-to-cart]');
      const image = section.querySelector('[data-tm-main-image]');
      if (price) {
        price.textContent = option.dataset.price + ' ';
        if (option.dataset.compare) {
          const oldPrice = document.createElement('del');
          oldPrice.textContent = option.dataset.compare;
          price.appendChild(oldPrice);
        }
      }
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Sold Out' : 'Add to Cart';
      }
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
        image.alt = option.dataset.alt;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    };
    select.addEventListener('change', updateVariant);
  });

});
